export default function getCurrentDomain(domain = window.location.hostname) {
  const parts = domain.split('.').reverse()
  return `${parts[1]}.${parts[0]}`
}
